// extracted by mini-css-extract-plugin
module.exports = {"icon":"EditButton_icon__1JJtk"};